import React from "react";
import {
  ErrorBoundary,
  SearchProvider,
  WithSearch
} from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import AppLayout from "./layout";
import buildConfig from "./config";

export default function App() {
  const searchParams = new URLSearchParams(window.location.search);
  return (
    <SearchProvider config={buildConfig(searchParams)}>
      <WithSearch mapContextToProps={({ wasSearched }) => ({ wasSearched })}>
        {({ wasSearched }) => {
          return (
            <ErrorBoundary>
              <AppLayout />
            </ErrorBoundary>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
